"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImplementationRulesAttemptSchema = exports.RulesRunOutcomeSchema = exports.RulesRunOutcome = exports.RulesRunCoverageSchema = exports.RulesRunCountsSchema = exports.ImplementationRuleSectionSchema = exports.ImplementationRuleSchema = exports.RuleModalitySchema = exports.RuleModality = void 0;
const z = require("zod");
const derive_rule_modality_1 = require("./derive-rule-modality");
const rule_citation_1 = require("./rule-citation");
var RuleModality;
(function (RuleModality) {
    RuleModality["Must"] = "must";
    RuleModality["MustNot"] = "must-not";
    RuleModality["Should"] = "should";
    RuleModality["ShouldNot"] = "should-not";
})(RuleModality || (exports.RuleModality = RuleModality = {}));
exports.RuleModalitySchema = z.nativeEnum(RuleModality);
exports.ImplementationRuleSchema = z
    .object({
    id: z.string(),
    text: z.string(),
    modality: exports.RuleModalitySchema,
    citations: rule_citation_1.RuleCitationSchema.array().min(1),
})
    .superRefine((rule, context) => {
    const derivation = (0, derive_rule_modality_1.deriveRuleModality)(rule.text);
    if (derivation.kind !== 'derived' || derivation.modality !== rule.modality) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['modality'],
            message: 'Rule modality must equal the modality derived from rule text',
        });
    }
});
exports.ImplementationRuleSectionSchema = z.object({
    sectionId: z.string(),
    sectionSlug: z.string().regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/),
    rules: exports.ImplementationRuleSchema.array(),
});
exports.RulesRunCountsSchema = z.object({
    factualErrors: z.number().int().nonnegative(),
    pinErrors: z.number().int().nonnegative(),
    polarityErrors: z.number().int().nonnegative(),
    gaps: z.number().int().nonnegative(),
    materialInventedRules: z.number().int().nonnegative(),
    scopeViolations: z.number().int().nonnegative(),
    formatIssues: z.number().int().nonnegative(),
    unresolvedConflicts: z.number().int().nonnegative(),
    droppedCandidates: z.number().int().nonnegative(),
    underivableCandidates: z.number().int().nonnegative(),
    fmCounts: z.record(z.string(), z.number().int().nonnegative()),
});
exports.RulesRunCoverageSchema = z.object({
    totalUnits: z.number().int().nonnegative(),
    completedUnits: z.number().int().nonnegative(),
    excludedUnits: z.number().int().nonnegative(),
    failedUnits: z.number().int().nonnegative(),
});
var RulesRunOutcome;
(function (RulesRunOutcome) {
    RulesRunOutcome["Complete"] = "complete";
    RulesRunOutcome["NoDatasheet"] = "no-datasheet";
    RulesRunOutcome["WrongDocument"] = "wrong-document";
    RulesRunOutcome["DegradedExtraction"] = "degraded-extraction";
    RulesRunOutcome["Failed"] = "failed";
})(RulesRunOutcome || (exports.RulesRunOutcome = RulesRunOutcome = {}));
exports.RulesRunOutcomeSchema = z.nativeEnum(RulesRunOutcome);
exports.ImplementationRulesAttemptSchema = z
    .object({
    id: z.string(),
    outcome: exports.RulesRunOutcomeSchema,
    startedAt: z.string().datetime(),
    completedAt: z.string().datetime().nullable(),
})
    .superRefine((attempt, context) => {
    if (attempt.completedAt !== null && Date.parse(attempt.completedAt) < Date.parse(attempt.startedAt)) {
        context.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['completedAt'],
            message: 'Attempt completion cannot precede its start',
        });
    }
});
//# sourceMappingURL=implementation-rules.js.map